<template>
  <div>
    <TitleCard :titleMsg1="titleMsg1" :titleMsg2="titleMsg2" :titleMsg3="titleMsg3" :titleMsg4="titleMsg4"></TitleCard>

    <a-card class="all-card-style ">

      <a-form-model :model="user" ref="user" :rules="FormRules" :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }" >

        <a-row>
          <a-col :span="8">
            <a-form-model-item prop="cUserCode" label="用户账号" class="ant-form-item2">
              <a-input v-model="user.cUserCode" placeholder="请输入" />
            </a-form-model-item>
          </a-col>

          <a-col :span="8">
            <a-form-model-item prop="cUserName" label="用户名称" class="ant-form-item2">
              <a-input v-model="user.cUserName" placeholder="请输入" />
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item prop="cPassword" label="用户密码" class="ant-form-item2">
              <a-input v-model="user.cPassword" placeholder="请输入" />
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item prop="cSex" label="性别" class="ant-form-item2">
              <a-select
                placeholder="请选择"
                v-model="user.cSex"  class="ant-form-item3"
              >
                <a-select-option value="男">
                  男
                </a-select-option>
                <a-select-option value="女">
                  女
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item prop="cRoleID" label="角色" class="ant-form-item2">
              <a-select
                placeholder="请选择"
                v-model="user.cRoleID"  class="ant-form-item3"
              >
                <a-select-option v-for="(item,index) in roleItems" :key="index" :value="item.ID">
                  {{item.cRoleName}}
                </a-select-option>

              </a-select>
            </a-form-model-item>
          </a-col>
<!--          <a-col :span="8">-->
<!--            <a-form-model-item prop="cPlatformID" label="项目">-->
<!--              <a-select-->
<!--                placeholder="请选择"-->
<!--                @change="platformSelect"-->
<!--                v-model="user.cPlatformID"-->
<!--              >-->
<!--                <a-select-option v-for="item in platformSelectItems" :value="item.ID">-->
<!--                  {{item.cPlatformName}}-->
<!--                </a-select-option>-->

<!--              </a-select>-->
<!--            </a-form-model-item>-->
<!--          </a-col>-->
<!--          <a-col :span="8">-->
<!--            <a-form-model-item prop="cSceneID" label="场地" >-->
<!--              <a-select-->
<!--                placeholder="请选择"-->
<!--                v-model="user.cSceneID"-->
<!--                :allowClear="true"-->
<!--              >-->

<!--                <a-select-option v-for="item in sceneformSelectItems" :value="item.ID">-->
<!--                  {{item.cSceneName}}-->
<!--                </a-select-option>-->

<!--              </a-select>-->
<!--            </a-form-model-item>-->
<!--          </a-col>-->
<!--          <a-col :span="8">-->
<!--            <a-form-model-item prop="cSceneID" label="场地2" >-->
<!--              <a-select-->
<!--                placeholder="请选择"-->
<!--                v-model="user.cSceneID2"-->
<!--                :allowClear="true"-->
<!--              >-->

<!--                <a-select-option v-for="item in sceneformSelectItems" :value="item.ID">-->
<!--                  {{item.cSceneName}}-->
<!--                </a-select-option>-->

<!--              </a-select>-->
<!--            </a-form-model-item>-->
<!--          </a-col>-->
          <a-col :span="8">
            <a-form-model-item  label="生日" class="ant-form-item2">
              <a-date-picker v-model="user.dBirthday" placeholder="请选择" />

            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item  label="手机" class="ant-form-item2">
              <a-input v-model="user.cMobile" placeholder="请输入" />
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item  label="邮箱" class="ant-form-item2">
              <a-input v-model="user.cEmail" placeholder="请输入" />
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item  label="微信" class="ant-form-item2">

              <a-input v-model="user.cWeChat" placeholder="请输入" />
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item prop="cAuthLevel" label="管理级别" class="ant-form-item2">
              <a-select
                placeholder="请选择"
                v-model="user.cAuthLevel"  class="ant-form-item3"
              >
                <a-select-option value="企业" class="ant-form-item2">
                  Enterprise-企业
                </a-select-option>

              </a-select>
            </a-form-model-item>
          </a-col>





          <a-col :span="8">
            <a-form-model-item  label="头像" class="ant-form-item2">
              <a-upload
                :action="uploadurl"
                list-type="picture"
                :default-file-list="fileList"
                @change="uploadchange"
              >
                <a-button> <a-icon type="upload" /> upload </a-button>
              </a-upload>

            </a-form-model-item>
          </a-col>
        </a-row>
				<a-row>
				  <a-col :span="10">
				  <a-form-model-item label="项目权限">
				    <a-transfer
				      :data-source="mockData"
				      :titles="['项目', '权限']"
				      :target-keys="targetKeys"
				      :selected-keys="selectedKeys"
				      :render="item => item.title"
				      :disabled="disabled"
				      @change="handleChange"
				      @selectChange="handleSelectChange"
				      @scroll="handleScroll"
				    />
				  </a-form-model-item>
				  </a-col>
				</a-row>

        <a-form-model-item :wrapper-col="{ span: 12, offset: 2 }">
          <a-button type="primary" html-type="button" @click="SaveForms">
            确定
          </a-button>
        </a-form-model-item>

      </a-form-model>


    </a-card>
  </div>
</template>

<script>
  import TitleCard from '@/components/TitleCard.vue'
  import { _getEntPlatFormData } from '@/common/request'

  export default {
    name: 'userForm',
    components: {
      TitleCard
    },
    data() {
      return {
        defSystemConfig:['4f4df094-1c11-4856-b688-1b8500d6a6b1'],
        systemCodeSelectItems:[],
        uploadurl:"",
        titleMsg1: "系统管理",
        titleMsg2:'用户管理',
        titleMsg3:'用户管理',
        titleMsg4:'新增',
        fileList:[],
        user:{},
        roleItems:[],
        platformSelectItems:[],
        sceneformSelectItems:[],
        enterpriseSelectItems:[],
        queryPlatformInfo:{
          cEntID:"",
          keyword:""
        },
		mockData:[],
		targetKeys:[],
		role:{},
		
		selectedKeys: [],
		disabled:false,
        FormRules:{

          cSystemCode:
            [
              { required: true, message: '请选择平台', trigger: 'blur' }
            ],
          cUserCode:
            [
              { required: true, message: '请输入用户账号', trigger: 'blur' }
            ],
          cUserName: [
            { required: true, message: '请输入用户名称', trigger: 'blur' }
          ],
          cPassword:[
            { required: true, message: '请输入用户密码', trigger: 'blur' }
          ],
          cSex:[
            { required: true, message: '请选择性别', trigger: 'change' }
          ],
		  cRoleID:[
		    { required: true, message: '请选择角色', trigger: 'change' }
		  ],
          cAuthLevel:[
            { required: true, message: '请选择管理级别', trigger: 'change' }
          ],
          cEntID:[
            { required: true, message: '请选择企业', trigger: 'change' }
          ],
          cPlatformID:[
            { required: true, message: '请选择项目', trigger: 'change' }
          ],
          cSceneID:[
            { required: true, message: '请选择场地', trigger: 'change' }
          ],
          cEntID:[
            { required: true, message: '请选择企业', trigger: 'change' }
          ],
          cAuthLevel:[
            { required: true, message: '请选择管理级别', trigger: 'change' }
          ],

        }

      }
    },
    mounted () {
      let that=this;
      that.queryPlatformInfo.cEntID=that.$store.getters.User.enterprise.ID;
      that.uploadurl=that.$http.defaults.baseURL+"User/Upload";
      if (that.$route.params.user){
        that.user=that.utils.deepClone(that.$route.params.user);

      if (that.user.cHeadImage){

        that.fileList.push({
          uid: that.user.cHeadImage,
          name: 'xxx.png',
          status: 'done',
          response: '', // custom error message to show
          url: that.$http.defaults.baseURL.slice(0,that.$http.defaults.baseURL.length-4)+that.user.cHeadImage,
        })
      }

      }

	  that.getRoles();
	  //that.getEntPlatFormData();
	  that.getEnterprise();
	  that.getUserSystemConfig();
	  that.getMenus();
	  that.getMenusByRoleId();

    },
    methods:{
		handleChange(nextTargetKeys, direction, moveKeys) {
		  this.targetKeys = nextTargetKeys;
		
		
		},
		handleSelectChange(sourceSelectedKeys, targetSelectedKeys) {
		  this.selectedKeys = [...sourceSelectedKeys, ...targetSelectedKeys];
		
		
		},
		handleScroll(direction, e) {
		
		},
		async getMenus(){ //获取当前项目
		  var _this=this
		  //console.log(_this.queryPlatformInfo);
		  let res=await _this.$http.post('EntPlatformInfo/List',_this.queryPlatformInfo)
		
		  if(res.data.code ==200){
		   var data=res.data.obj.list
		
		    data.forEach((ele,index)=>{
		      _this.mockData.push({
		        key: ele.ID,
		        title: ele.cPlatformName,
		        // description: ele.href,
		        disabled: false,
		      });
		    })
		
		  }
		
		},
		async getMenusByRoleId(){
		  var _this=this
		  console.log('111');
		  console.log(_this.user.enterPlatID);
		 
		  var strsKey = new Array();
		  strsKey = _this.user.enterPlatID.split(","); //字符分割
		
		  for (let x = 0; x < strsKey.length; x++) {
		      _this.targetKeys.push(strsKey[x]);
		  }
		
		
		  //return;
		  // let res=await _this.$http.post('Role/RoleMenuList?roleId='+_this.role.ID,null)
		
		  // if(res.data.code ==200){
		  //   var data=res.data.obj.list
		
		  //   data.forEach((ele,index)=>{
		  //     _this.targetKeys.push(
		  //        ele.ID
		
		  //     );
		  //   })
		  // }
		
		},
      onUserSystemConfigChange(val){

        var that=this
       /* var that=this
    let scArr=   that.user.cSystemCode;


  scArr.push(val);

 that.user.cSystemCode=scArr;
    */
  },
      async   getUserSystemConfig(){
        var that=this
        let res =  await that.$http.post('User/GetUserSysConfig?ID='+that.user.ID+'&cEntID=' + that.queryPlatformInfo.cEntID,{})

      that.systemCodeSelectItems=  res.data.obj.list;

    let scArr=[];
      if(res.data.obj.userList!=null){
        for(let i  in res.data.obj.userList){
          scArr.push(res.data.obj.userList[i].cSystemCode);
        }
      }
      if(scArr.length==0&& res.data.obj.list!=null&& res.data.obj.list.length>0){
        scArr.push(res.data.obj.list[0].ID);
      }

        //   that.user.cSystemCode= res.data.obj.list;
      //  that.user.cSystemCode=scArr;

      },
      uploadchange(e){
        let that=this;

       if (e.file){

         that.user.cHeadImage=that.$http.defaults.baseURL.slice(0,that.$http.defaults.baseURL.length-4)+e.file.response.Id;

       }

      },
      platformSelect(){

        this.getSceneData()

      },
//角色
      async getRoles(){
        var _this=this
        let res=await _this.$http.post('Role/List2?cEntID='+_this.queryPlatformInfo.cEntID+"&cSystemCode=设施园艺",null)

        if(res.data.code ==200){
          let roles=res.data.obj.list
          if(!_this.roleItems){
            _this.roleItems=[]
          }
          roles.forEach((ele,index)=>{

            _this.roleItems.push({ID:ele.ID,cRoleName:ele.cRoleName})
          })
        }
      },
      /*获取项目列表*/
      async getEntPlatFormData(){
        var that=this
        let res=await  _getEntPlatFormData(this,this.queryPlatformInfo)


        if(res.data.data.code=="200"){

          that.platformSelectItems=res.data.data.obj.list
          if(that.platformSelectItems.length>0) {
            that.user.cPlatformID=that.platformSelectItems[0].ID

            this.getSceneData()
          }
        }

      },
      //企业
      async getEnterprise(){
        var that=this
        let res=await that.$http.post('Enterprise/List',null)

        if(res.data.code=="200"){

          that.enterpriseSelectItems=res.data.obj.list
        }


      },
      //场地
      async getSceneData(){
        var that=this
        let res=await that.$http.post('EntSceneInfo/List',{cSystemCode:'设施园艺',cPlatformID:that.user.cPlatformID})

        if(res.data.code=="200"){

          that.sceneformSelectItems=res.data.obj.list
        }

      },
      async SaveForms () {
        let that = this;

        that.user.cRoleName=that.roleItems.filter(s=>s.ID==that.user.cRoleID)[0].cRoleName;

        that.user.cSystemCode=that.defSystemConfig.join(',');
          that.user.cEntID=that.$store.getters.User.enterprise.ID;

          that.$refs['user'].validate(async valid => {
		  if(!that.targetKeys||that.targetKeys.length==0){
		    that.$message.error('请分配项目权限!')
		    return ;
		  }
          if (valid) {
            let res = await that.$http.post('User/Save?enterPlatID=' + that.targetKeys , that.user)

            if (res.data.code == "200") {
              that.$message.success('保存成功!')
              that.$router.push({ name: 'UserList' });
            } else {

              that.$message.error(res.data.message)

            }
          } else {
            that.$message.error('校验失败!')
          }
        });
      }
    }
  }
</script>
<style scoped>
.upload-list-inline >>> .ant-upload-list-item {
float: left;
width: 200px;
margin-right: 8px;
}
.upload-list-inline >>> .ant-upload-animate-enter {
animation-name: uploadAnimateInlineIn;
}
.upload-list-inline >>> .ant-upload-animate-leave {
animation-name: uploadAnimateInlineOut;
}
</style>

